import { getAgeIdByTitle } from '@/pages/Onboarding/options/Age/utils/getAgeIdByTitle';
import { getBodyShapeIdByTitle } from '@/pages/Onboarding/options/BodyShape/utils/getBodyShapeIdByTitle';
import { getHairColorIdByTitle } from '@/pages/Onboarding/options/HairColor/utils/getHairColorIdByTitle';
import { getMajorTurnOffIdByTitle } from '@/pages/Onboarding/options/MajorTurnOff/utils/getMajorTurnOffIdByTitle';

import { COMMUNUCATE_OPTIONS } from '../../OwnAI/screens/Communicate/constants';
import { ETHNICITY_OPTIONS } from '../../OwnAI/screens/Ethnicity/constants';
import { INTERACTION_OPTIONS } from '../../OwnAI/screens/Interaction/constants';
import { OBEDIENCE_OPTIONS } from '../../OwnAI/screens/Obedience/constants';
import { getPersonalityDefault } from '../../OwnAI/utils/getPersonalityDefault';
import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = Omit<
  LayoutDataType,
  | 'body_shape'
  | 'communicate'
  | 'ethnicity'
  | 'hair_color'
  | 'interaction'
  | 'major_turn_off'
  | 'obedience'
> & {
  body_shape: string;
  communicate: string;
  ethnicity: string;
  hair_color: string;
  interaction: string;
  major_turn_off: string;
  obedience: string;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    age: getAgeIdByTitle(onb_data.age),
    body_shape: getBodyShapeIdByTitle(onb_data.body_shape),
    communicate:
      COMMUNUCATE_OPTIONS.find(
        (option) => option.title === onb_data.communicate,
      )?.id ?? null,
    ethnicity:
      ETHNICITY_OPTIONS.find((option) => option.title === onb_data.ethnicity)
        ?.id ?? null,
    hair_color: getHairColorIdByTitle(onb_data.hair_color),
    interaction:
      INTERACTION_OPTIONS.find(
        (option) => option.title === onb_data.interaction,
      )?.id ?? null,
    major_turn_off: getMajorTurnOffIdByTitle(onb_data.major_turn_off),
    obedience:
      OBEDIENCE_OPTIONS.find((option) => option.title === onb_data.obedience)
        ?.id ?? null,
    personality: onb_data.personality || getPersonalityDefault(),
    name: onb_data.name || layoutDataDefault.name,
    send_photos: onb_data.send_photos || layoutDataDefault.send_photos,
  };
};
